import React from 'react';
import { formatNumber } from '../../utils/dataHelpers';

interface MetricSummaryProps {
  title: string;
  value: number | null;
  description?: string;
  unit?: 'number' | 'seconds' | 'percentage' | 'currency';
  currency?: string;
}

const MetricSummary: React.FC<MetricSummaryProps> = ({ title, value, description, unit = 'number', currency }) => {
  let formattedValue = '-';

  if (value !== null) {
    switch (unit) {
      case 'percentage':
        formattedValue = `${formatNumber(value, 2)}%`;
        break;
      case 'seconds': {
        const minutes = Math.floor(value / 60);
        const seconds = Math.round(value % 60);
        formattedValue = `${minutes}dk ${seconds}sn`;
        break;
      }
      case 'currency':
        formattedValue = new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: currency ?? 'TRY',
          maximumFractionDigits: 2
        }).format(value);
        break;
      default:
        formattedValue = formatNumber(value);
    }
  }

  return (
    <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl p-6">
      <h3 className="text-sm font-medium text-white/60 uppercase tracking-wide">{title}</h3>
      <div className="mt-3 text-3xl font-semibold text-white">{formattedValue}</div>
      {description && <p className="mt-2 text-sm text-white/50">{description}</p>}
    </div>
  );
};

export default MetricSummary;

